import { useContext, useState } from "react";
import Team from "../../assets/images/Team.svg";
import Black from "../../assets/images/Black.svg";
import money from "../../assets/images/money.svg";
import logo from "../../assets/images/Logo.svg";
import saveMoney from "../../assets/images/saveMoney.svg";
import "./Employees.css";
import Pictures from "../Pictures/Pictures";
import { useRef } from "react";
import { useEffect } from "react";
import { useMainContext } from "../../context/manageContext";
const Employees = ({showMindReset,setShowMindReset}) => {
  let data = useMainContext();
  const [next, setNext] = useState(false);
  // const [showMindReset, setShowMindReset] = useState(false);
  const [showRes, setShowRes] = useState(false);
  const [res, setRes] = useState({ yearLost: 0, yearSaved: 0 });
  const [numOfEmployees, setNumOfEmployees] = useState(10);
  const [totalSalaries, setAvgSalary] = useState(0);
  let employeesThatHaveHighBurnout = 0.35;
  let burnoutLoss = 0.34;
  let mindResetSave = 0.57;
  const handleChange = (e) => {
    let value = e.target.value.replace(/,|\./g, "");

    if (!isNaN(value)) {
      setAvgSalary(value);
    }

  };
  const handleEmpChange = (e) => {
    let value = e.target.value.replace(/,|\./g, "");
    // value = value.replace(/./g, "")
    if (!isNaN(value)) {
      setNumOfEmployees(value);
    }

  };
  let updateTheContext = () => {
    data.setData({ employees: numOfEmployees, totalSalary: totalSalaries });
    //calc results here
    let totalEmployeesWithHighBurnout = numOfEmployees * employeesThatHaveHighBurnout;
    let moneyLostInAYear = (totalEmployeesWithHighBurnout * (totalSalaries / numOfEmployees) * burnoutLoss
    );
    let moneySavedInAYear = ((totalEmployeesWithHighBurnout * (totalSalaries / numOfEmployees) * burnoutLoss) * mindResetSave
    );
    setRes({ ...res, yearLost: moneyLostInAYear, yearSaved: moneySavedInAYear });
    setShowRes(!showRes);
  };

  const inputRef = useRef();
  useEffect(() => {
    // inputRef.current?.focus()
  }, [next])

  return (
    <>
    <div className="outer-main-calculator">
      <div className={`calc-container ${showMindReset ? "move-to-side" : ""}`}>
        <div className="hero">
          <img src={logo} />
          <span className="font-regular" >Welcome to
            <b className="font-bold">
              {" "}  Mind Reset!
            </b>
          </span>
        </div>



        {!next && !showRes && !showMindReset && (
          <div className="breakInItem container-calculator">
            <div >
              <img src={Team} />
            </div>
            <h2> How many employees do you have?</h2>
            <div className="input-container">

              <input
                ref={inputRef}
                className="input-calc"
                min={10}

                type="text"
                value={Number(numOfEmployees).toLocaleString()}
                onInput={handleEmpChange}
              />
              {numOfEmployees < 10 && <span className="alert">Minimum 10 employees</span>}
            </div>

            <button className="fig-btn" disabled={numOfEmployees < 10} onClick={() => setNext(!next)}>Next</button>

          </div>
        )}
        {next && !showRes && !showMindReset && (
          <div id="employeesSecondScreen" className="fadeInItem container-calculator">
            <div>

              <img src={Black} />
            </div>
            <span className="info-text">
              Did you know that<b> 79% of employees </b>in the UK experience burnout, <b>35%</b> of them high to extreme levels?
            </span>
            <h2> What is the total yearly cost of all of the company salaries?</h2>

            <div className="input-container">
              £
              <input
                ref={inputRef}
                className="input-calc"
                placeholder=" Enter here"
                min={0}
                type="text"
                value={Number(totalSalaries).toLocaleString()}
                onChange={
                  handleChange
                }
              />
            </div>

            <button className={"fig-btn"} disabled={totalSalaries <= 0} onClick={() => updateTheContext()}>Next</button>
          </div>
        )
        }
        {
          showRes && (
            <div className="fadeInItem container-calculator">
              <div>
                <img src={money} />
              </div>
              <div className="explain-container">
                <h2 className="h2-nopadd">Your Burnout Cost</h2>
                <div >
                  Did you know employees with burnout cost you
                  <b>
                    {" "}34% of their annual salary?
                  </b>
                </div>
                <div >
                  Assuming only 35% of your team are suffering from burnout - you're losing every year
                  <b>
                    {" "}at least £{parseInt(res.yearLost).toLocaleString()} !!
                  </b>
                </div>
              </div>
              <h2> What if your employees used Mind Reset?</h2>
              <button
                className="fig-btn"
                onClick={() => {
                  setShowMindReset(!showMindReset);
                  setShowRes(false);
                  setNext(false);
                }}
              >
                Next
              </button>
            </div>
          )
        }
        {
          showMindReset && (
            <div id="resScreen" className="flipInItem container-calculator">
              <div>
                <img src={saveMoney} />
              </div>
              <span>With Mind Reset you could be saving at least  <b>£{parseInt(res.yearSaved).toLocaleString()} a year !!</b></span>
              <h2>Mind Reset in just one month (<span className="font-regular">up to 2 min a day</span>) reduced burnout by 38%, moving 57% of the team below risk levels! </h2>
              <a href="#contact-us">
                <button className="fig-btn" onClick={() => setShowMindReset(true)}>
                  Contact us now!
                </button>
              </a>
            </div>
          )
        }
      </div >
      </div>
      {/* {showMindReset && <Pictures />} */}
    </>

  );
};
export default Employees;
